module.exports = __webpack_public_path__ + "static/6-288942403be69eee2253b565a237e1d0.svg";